/** @format */

import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import ExpenseItem from "./ExpenseItem";

const ExpensesList = ({ filteredExpense }) => {
	let expensesContent = (
		<h3 className='expenses-list__fallback'>Found no expenses. </h3>
	);

	if (filteredExpense.length > 0) {
		expensesContent = filteredExpense.map((item) => {
			return (
				<ExpenseItem
					key={uuidv4()}
					title={item.title}
					id={item.title}
					amount={item.amount}
					date={item.date}
				/>
			);
		});
	}

	return <ExpensesListWrapper>{expensesContent}</ExpensesListWrapper>;
};

export default ExpensesList;

const ExpensesListWrapper = styled.ul`
	list-style: none;
	padding: 0;

	.expenses-list__fallback {
		color: white;
		text-align: center;
	}
`;
